import { ENDPOINTS, SOCKET_BASE_URL, BASE_URL } from "../constants/urls";

const contentSSE = ENDPOINTS.SSE_CONTENT;
const paymentSSE = ENDPOINTS.SSE_PAYMENT;
const paymentSocketUrl = ENDPOINTS.PAYMENT_STATUS_SOCKET;

export const connectSocket = (id, blogId, uuid) => {
  const url = `${BASE_URL.BASE_URL}${contentSSE}/?uniqueId=${id}&blogId=${blogId}&uuid=${uuid}`;

  const eventSource = new EventSource(url);

  // Add connection logging
  eventSource.addEventListener('open', () => {
    console.log('🟢 SSE connection established');
  });

  eventSource.addEventListener('error', (error) => {
    console.error('🔴 SSE connection error:', error);
  });

  return eventSource;
};
export const connectPaymentStatusSocket = (id, uuid) => {
  try {
    const uuidParam = uuid ? `&uuid=${uuid}` : '';
    return new EventSource(`${BASE_URL.BASE_URL}${paymentSSE}/?uniqueId=${id}${uuidParam}`);
  } catch (err) {
    return null;
  }
};

export const getSocket = (id) => {
  console.log(id);
  var connections = useSelector((state) => state.connections.data?.data);
  console.log(connections);
  return connnections[id] || null;
};

export const disconnectSocket = (id) => {
  if (connnections[id]) {
    connnections[id].close();
    delete connnections[id];
  }
};
